import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const lifestyleInsuredDrugsCocaine: AnswerPathTreeNode = {
  path: 'lifestyleInsuredDrugsCocaine',
  children: [
    {
      path: 'use',
      children: [
        { path: 'stillConsume', nodeId: NodeIds.lifestyleInsuredDrugsCocaineUseStillConsume },
        { path: 'startDate', nodeId: NodeIds.lifestyleInsuredDrugsCocaineUseStartDate },
        { path: 'endDate', nodeId: NodeIds.lifestyleInsuredDrugsCocaineUseEndDate },
      ],
    },
    {
      path: 'consumptionHabits',
      children: [
        { path: 'quantity', nodeId: NodeIds.lifestyleInsuredDrugsCocaineConsumptionHabitsQuantity },
        { path: 'frequency', nodeId: NodeIds.lifestyleInsuredDrugsCocaineConsumptionHabitsFrequency },
      ],
    },
    {
      path: 'pastConsumptionHabits',
      children: [
        { path: 'quantity', nodeId: NodeIds.lifestyleInsuredDrugsCocainePastConsumptionHabitsQuantity },
        { path: 'frequency', nodeId: NodeIds.lifestyleInsuredDrugsCocainePastConsumptionHabitsFrequency },
      ],
    },
    {
      path: 'pastUse',
      children: [
        { path: 'use', nodeId: NodeIds.lifestyleInsuredDrugsCocainePastUse },
        { path: 'startDate', nodeId: NodeIds.lifestyleInsuredDrugsCocainePastUseStartDate },
        { path: 'endDate', nodeId: NodeIds.lifestyleInsuredDrugsCocainePastUseEndDate },
      ],
    },
    {
      path: 'pastChangeHabitConsumption',
      children: [
        { path: 'date', nodeId: NodeIds.lifestyleInsuredDrugsCocainePastChangeHabitConsumptionDate },
        { path: 'reason', nodeId: NodeIds.lifestyleInsuredDrugsCocainePastChangeHabitConsumptionReason },
      ],
    },
  ],
};
